export const READY_EVENTS = {
  READY: 'ready',
  READY_ACK: 'ready_ack',
} as const;
export type ReadyEvent = (typeof READY_EVENTS)[keyof typeof READY_EVENTS];
